<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-access-control`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v36a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h36zm-2 4H8v32h32V8zm-23.423 7.56c-.371-.16-.828-.205-.974.043-.248.146-.204.603-.044.974l2.44 10.4a1.375 1.375 0 00.308.516.528.528 0 01.019.022c.007.01.015.019.024.028l.016.013.014.012c.038.038.079.073.144.124.231.175.5.277.746.255.021-.002.04-.007.06-.012a.957.957 0 01.024-.006l.014-.002a.356.356 0 00.102-.034.562.562 0 00.093-.05l.012-.007c.026-.017.051-.034.073-.056l2.652-2.652 7.79 7.79c.263.263.635.319.83.124l2.122-2.122c.195-.195.14-.567-.124-.83l-7.79-7.79 2.652-2.652c.021-.02.037-.045.057-.073l.013-.02a.617.617 0 00.043-.085.626.626 0 00.034-.102l.002-.014a.957.957 0 01.006-.024c.005-.02.01-.039.012-.06.022-.245-.08-.515-.273-.769a1.506 1.506 0 00-.118-.135l-.013-.016-.028-.024a.528.528 0 01-.032-.028 1.38 1.38 0 00-.505-.298l-10.4-2.44z"/></svg>
</template>
<script>

export default {
  name: 'IconAccessControl',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
